export default "<template>\n  <div>\n    <FdCalendar defaultValue=\"2010-02-01\" />\n  </div>\n</template>"